import { config } from "@app-contexts/sdk/services/config";
import { Widget, WidgetQueryParams } from "@app-contexts/sdk/services/Widget";
import { queryParamSerializer } from "@shared/utils/url";

/**
 * @deprecated no longer supported in v2
 */
export async function loginWidget(
  params: WidgetQueryParams
): Promise<Widget | null> {
  const queryString = queryParamSerializer(params);

  if (config.flag("sdk_use_nextjs_login_widget")) {
    const url = `${await config.loginWidgetUrl()}?${queryString}`;
    const popup = window.open(url, "", "width=400,height=700");

    window.addEventListener("message", () => {
      popup?.close();
    });

    return null;
  }

  const widget = new Widget({
    src: await config.loginWidgetUrl(),
    queryParams: params,
  });

  widget.show();

  return widget;
}
